$(document).ready(function () {

    /**************************************************
     * loading screen
     **************************************************/
    //$('.loading-screen').fadeOut();
    /*$(window).on('beforeunload', function() {
      $('.loading-screen').fadeIn();
    })*/
    initMobileMenu();
    stickyHeader();
    reSizeCaptcha();
    initAdsSlider();
    //initHomeBanner();

    $('.back-to-top').click(function () {
        $('body, html').animate({
            scrollTop: 0
        }, 100);
        return false;
    });
    imgToBG($(".bg-img"), ".img-bg");
});

//add simple support for background images:
/*document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});*/

$(window).on("scroll", function () {
    stickyHeader();
});

window.captchaCallback = function(response) {
    $(".g-recaptcha").val(response);
};

$(window).on('load',function() {
    $('.search-toggle').on('click', function(){
        $(this).toggleClass('active');
        $('.search-form').toggleClass('active');
        $('.menu-right').toggleClass('active');
    });
});

window.captchaCallback = function(response) {
    $(".g-recaptcha").val(response);
};

function initMobileMenu() {
    /*var mmenu = new MmenuLight($("#mobile-menu").get(0), {
        title: "Menu",
        selected: "active",
    });

    mmenu.enable("(max-width: 1200px)");
    mmenu.offcanvas({
        position: "left",
        move: true,
        blockPage: true,
    });

    $("#mobile-menu").addClass("mm");

    $('a[href="#mobile-menu"]').on("click", function(ev) {
        mmenu.open();

        ev.preventDefault();
        ev.stopPropagation();
    });*/
    $("#mobile-menu").mmenu({
        "extensions": [
            "pagedim-black"
        ],
        "navbar": {
            "title": ""
        },
        "navbars": [
            {
                "position": "bottom",
                //"content": [$('#social_icon').html()]
                "content": [$('.social-icon').html()]
            }
        ]
    });
}

function stickyHeader() {
    if ($(window).scrollTop() > $("header").innerHeight()) {
        $("header").addClass("sticky");
    } else {
        $("header").removeClass("sticky");
    }
}

window.reSizeCaptcha = function(parent = "") {
    if ($(parent + ".g-recaptcha").length) {
        var width = $(parent + ".g-recaptcha")
            .parent()
            .width();
        if (width > 150 && width < 330) {
            var scale = (width - 5) / 302;

            $(parent + ".g-recaptcha").css("transform", "scale(" + scale + ")");
            $(parent + ".g-recaptcha").css("-webkit-transform", "scale(" + scale + ")");
        } else {
            $(parent + ".g-recaptcha").css("transform", "unset");
            $(parent + ".g-recaptcha").css("-webkit-transform", "unset");
        }
    }
}

function initAdsSlider() {
    if ($(".ads").length) {
        var adsSwiper = new Swiper(".ads .swiper-container", {
            loop: true,
            autoplay: {
                delay: 5000,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });
    }
}

function imgToBG(bgClass, imageClass) {
    if (bgClass.length > 0) {
        bgClass.each(function() {
            var img = $(this).find(imageClass).eq(0);

            $(this).css({
             "background-image": 'url("' + img.attr("src") + '")',
             });
            //$(this).attr('data-bg', img.attr("src"));
            img.hide();
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/front/unocms-v4/main.js